import React, { Component } from 'react';
import { Upload, message } from 'antd';

import { inject, observer } from 'mobx-react';
import K from '../../../../../constants';
import { api } from '../../../../../services';

import './UploadFile.css';

import classNames from 'classnames';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const formats = ['image/jpeg', 'image/png', 'image/gif'];

  const isAValidFormat = formats.indexOf(file.type) !== -1;
  if (!isAValidFormat) {
    message.error('You cannot upload this format!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isAValidFormat && isLt2M;
}

@inject('translationsStore', 'commonStore', 'authStore')
@observer
export default class UploadFile extends Component {
  state = {
    loading: false
  };

  handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });

      return;
    }
    if (info.file.status === 'done') {
      api('dealer profile').then(dealer => {
        this.props.commonStore.setDealer(dealer);
      });
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false
        })
      );
    }
  };

  render() {
    const { commonStore } = this.props;
    const uploadButton = (
      <div className="uploadButton">
        <div className="user-icon-bg" />
        <div className="imageContainer">
          {!!commonStore.dealer && !!commonStore.dealer.logo ? (
            <div className="imageContainer">
              <img src={commonStore.dealer.logo} alt="avatar" className="image-icon-bg" />
            </div>
          ) : (
            this.props.image
          )}
        </div>
        <div className={this.props.labelClassName}>{this.props.label} </div>
      </div>
    );

    const cls = classNames({
      UploadFile: true,
      [this.props.className]: !!this.props.className
    });

    const url = `${K.API_URL}/dealers/logo`;

    return (
      <Upload
        name="avatar"
        showPreviewIcon={true}
        showUploadList={false}
        action={url}
        headers={{ Authorization: this.props.authStore.token }}
        beforeUpload={beforeUpload}
        onChange={this.handleChange}
        {...this.props}
        className={cls}
      >
        {uploadButton}
      </Upload>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/SubHeader/UploadFile/UploadFile.js